export const currency = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'XAF',
});

